import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { ADMIN_TOKEN_KEY, adminApi } from "@/lib/admin-api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const t = localStorage.getItem(ADMIN_TOKEN_KEY);
      if (t) {
        try {
          const me = await adminApi("/admin/auth/me");
          setAdmin(me);
        } catch {
          localStorage.removeItem(ADMIN_TOKEN_KEY);
        }
      }
      setLoading(false);
    })();
  }, []);

  const login = useCallback(async (email, password, totp) => {
    const res = await adminApi("/admin/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password, totp: totp || undefined }),
    });
    localStorage.setItem(ADMIN_TOKEN_KEY, res.access_token);
    setAdmin(res.user);
  }, []);

  const logout = useCallback(async () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setAdmin(null);
  }, []);

  const value = useMemo(() => ({ admin, loading, login, logout }), [admin, loading, login, logout]);
  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be inside <AdminAuthProvider>");
  return ctx;
}
